import { Card } from "@/components/ui/card"

export function LoginFrame({ children }: { children: React.ReactNode }) {
  return (
    <div className="grid min-h-svh place-items-center bg-muted/30 p-6">
      <Card className="w-full max-w-md">{children}</Card>
    </div>
  )
}
